import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterNFC{
    page?: number;
    sort?: string;
    chantierIds?: number[];
    siteIds?: number[];
    localisation?: string;
    isActif?: boolean;
}
export interface HistoriqueNFC{
    pageable?: Pageable;
    numeroNFC: string;
}

export interface Pageable {
    page?: number;
    sort?: string;
}

class NFCService {
    public async getNFC(params: FilterNFC): Promise<any>{
        return http.get(Routes.NFC.GetNFCTags(), {params});
    }
    public async getHistoriqueNFC(params: HistoriqueNFC): Promise<any>{
        const pageable = params.pageable;
        return http.get(Routes.NFC.GetHistoriqueNFC(params.numeroNFC), {params:pageable});
    }
    public async getExportXlsNFC(params: FilterNFC): Promise<any> {
        return http.get(Routes.NFC.GetExportXlsNFC(), { params, responseType: 'arraybuffer' });
    }
}

export default new NFCService();
